import React from "react";
import { Typography } from "antd"; // Ant Design Typography
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";

const { Title } = Typography;

const Header = () => {
  return (
    <div className="bg-gray-100 p-4">
      <header className="flex items-center justify-center space-x-3 bg-blue-500 p-4 rounded shadow-md">
        <FontAwesomeIcon icon={faChartLine} className="text-white text-2xl" />
        <Title level={2} className="text-white mb-0">
          Market Pulse
        </Title>
      </header>
    </div>
  );
};

export default Header;
